import { changeDateFormat } from "../../utils/helpers/text";
import { getFieldValue } from "../booking-instruments/helpers";

/**
 * Renders any date column, keyed off the column being rendered rather than a hard-coded list.
 *
 * `getColumnObj` attaches this to every key in `listOfDateRequired()`, which is now derived from
 * the schema (`filter === DATE`) rather than hand-written. The hand-written list held exactly the
 * two maintenance dates this used to name, so naming them worked; the derived list also carries
 * `dateOfLastCalibration`, `createdAt` and `updatedAt`, which fell through to the dash and read as
 * empty cells against data that was there all along.
 *
 * `getFieldValue` resolves both search shapes — CloudSearch returns each field as an array,
 * OpenSearch as a scalar.
 */
const DateRender = (params) => {
  const dateValue = getFieldValue(params?.data, params?.column?.colId);

  if (!dateValue) {
    return <div>-</div>;
  }

  return <div>{changeDateFormat(dateValue, "DD-MMM-YYYY")}</div>;
};

export default DateRender;
